import { api, config, rest } from '../../../helpers/api';
import { generatePath } from 'react-router-dom';

export function sendKudosRequest({
  receiverId,
  receiverIds,
  cardId,
  coin,
  note
}) {
  return api.post(
    generatePath(rest.KUDOS),
    {
      receiver_id: receiverId,
      receiver_ids: receiverIds,
      card_id: cardId,
      coin,
      note
    },
    config('json')
  );
}
